import { LineItemWithAmounts } from '../../../utils/customTypes';
import { ParentOfLineItems } from '../../../utils/types/budget';
export const buildNoParentEntity = (
  title: string,
  filterKey: keyof typeof lineItems[0],
  entities: ParentOfLineItems[],
  lineItems: LineItemWithAmounts[] = [],
  filteredTeams: any[] | undefined,
  additionalFilterKey?: keyof typeof lineItems[0]
) => {
  let filteredItems = lineItems;
  let strictlyTeamTypeLineItems: LineItemWithAmounts[] = [];
  let lineItemsToProcess: LineItemWithAmounts[] = [];
  if (lineItems) {
    strictlyTeamTypeLineItems = lineItems.filter((item) =>
      Object.prototype.hasOwnProperty.call(item, 'learningTeamId')
    );
  }
  let lineItemsWithoutTeam: LineItemWithAmounts[] = [];
  const rawAmounts = Array(12).fill(0);
  const rawActuals = Array(12).fill(0);
  if (additionalFilterKey) {
    filteredItems = lineItems.filter(
      (item) => !item[filterKey] && !item[additionalFilterKey]
    );
  } else {
    filteredItems = lineItems.filter((item) => !item[filterKey]);
  }
  if (filterKey === 'learningTeamId' && strictlyTeamTypeLineItems.length > 0) {
    const teamIds = filteredTeams?.map((team) => team.id);
    lineItemsWithoutTeam = strictlyTeamTypeLineItems.filter(
      (item) => !teamIds?.includes(item.learningTeamId as string)
    );
    lineItemsToProcess = lineItemsWithoutTeam;
  } else {
    lineItemsToProcess = filteredItems;
  }
  lineItemsToProcess.forEach((item) => {
    item.rawAmounts.forEach((amount, index) => {
      rawAmounts[index] += amount;
    });
    item.rawActuals.forEach((actual, index) => {
      rawActuals[index] += actual;
    });
  });

  const newEntity = {
    id: 'none',
    title,
    parentId: undefined,
    type: filterKey,
    rawAmounts,
    rawActuals,
    lineItems: lineItemsToProcess,
    children: [],
  };

  return newEntity;
};

export default buildNoParentEntity;
